import Header from "@commons/header";
import Column from "@components/column";
import Row from "@components/row";
import Table from "@components/table";
import Tab from "@components/tabs";
import React from "react";
import DeliveryManTable from "../DeliveryManListTable";

const PendingDeliveryManRequest = () => {
  const items: any = [
    {
      label: "Pending Delivery Man",
      component: DeliveryManTable,
      props: { type: "pending" },
    },
    {
      label: "Denied Deliveryman",
      component: DeliveryManTable,
      props: { type: "rejected" },
    },
  ];
  return (
    <Column>
      <Header title="New Joining Requests" />
      <Tab items={items} fitContent />
    </Column>
  );
};

export default PendingDeliveryManRequest;
